<div [formGroup]="popupEditForm">
  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label" for="startDate">{{ 'i18n.domain.popups.fields.startDate' | translate }}</label>
      <ejs-datetimepicker id="startDate"
                          formControlName="startDate"
                          [showClearButton]="true"
                          format="dd.MM.yyyy HH:mm">
      </ejs-datetimepicker>
    </div>
    <div class="col-6">
      <label class="form-label" for="endDate">{{ 'i18n.domain.popups.fields.endDate' | translate }}</label>
      <ejs-datetimepicker id="endDate"
                          formControlName="endDate"
                          [showClearButton]="true"
                          format="dd.MM.yyyy HH:mm">
      </ejs-datetimepicker>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label" for="platform">{{ 'i18n.domain.popups.fields.platform' | translate }}</label>
      <ejs-multiselect id="platform"
                       formControlName="platform"
                       [dataSource]="platformOptions"
                       [closePopupOnSelect]="false"
                       [fields]="dropdownFields">
      </ejs-multiselect>
    </div>
    <div class="col-6">
      <label class="form-label" for="versionComparison">{{ 'i18n.domain.popups.fields.versionComparison' | translate }}</label>
      <ejs-dropdownlist id="versionComparison"
                        formControlName="versionComparison"
                        [dataSource]="versionComparisonOptions"
                        [fields]="dropdownFields">
      </ejs-dropdownlist>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label" for="version">{{ 'i18n.domain.popups.fields.version' | translate }}</label>
      <input id="version" class="form-control e-textbox" formControlName="version" placeholder="e.g. 1.0.0" />
    </div>
  </div>

  @if (translationsArray.length > 0) {
    <div class="row mb-3">
      <div class="col-12">
        <label class="form-label">{{ 'i18n.domain.popups.fields.translations' | translate }}</label>
        <ejs-tab [animation]="tabAnimation">
          <e-tabitems>
            @for (tGroup of translationsArray.controls; track tGroup; let i = $index) {
              <e-tabitem>
                <ng-template #headerText>
                  <span [class.tab-header-invalid]="tGroup.controls.title.invalid || tGroup.controls.body.invalid">
                    {{ tGroup.controls.language.value | uppercase }}
                  </span>
                </ng-template>
                <ng-template #content>
                  <div [formGroup]="tGroup" class="p-3">
                    <div class="mb-2">
                      <label class="form-label">{{ 'i18n.domain.popups.fields.translation-title' | translate }}</label>
                      <input class="form-control e-textbox"
                             formControlName="title"
                             [class.is-invalid]="tGroup.controls.title.invalid && tGroup.controls.title.touched" />
                      @if (tGroup.controls.title.invalid && tGroup.controls.title.touched) {
                        <div class="invalid-feedback d-block">{{ 'i18n.validation.required' | translate }}</div>
                      }
                    </div>
                    <div>
                      <label class="form-label">{{ 'i18n.domain.popups.fields.translation-body' | translate }}</label>
                      <textarea class="form-control e-textbox"
                                formControlName="body"
                                rows="4"
                                [class.is-invalid]="tGroup.controls.body.invalid && tGroup.controls.body.touched"></textarea>
                      @if (tGroup.controls.body.invalid && tGroup.controls.body.touched) {
                        <div class="invalid-feedback d-block">{{ 'i18n.validation.required' | translate }}</div>
                      }
                    </div>
                  </div>
                </ng-template>
              </e-tabitem>
            }
          </e-tabitems>
        </ejs-tab>
      </div>
    </div>
  }
</div>
